import { plainToClassFromExist } from 'class-transformer';
import { concatMap, map, tap } from 'rxjs';
import { httpService } from '@services/http';
import { FindAllQueryDto, FindAllQueryResponseDto } from '@models';
import { HttpServiceBase, RxUtils, TypeUtils } from '@utils';
import { AdminStatistics } from './admin-statistics.class';
import { UserInvitation } from '../user-invitation';

export class AdminService extends HttpServiceBase {
	constructor() {
		super('admin');
	}

	getStatistics() {
		return httpService.get<AdminStatistics>(this.getUrl(), `statistics`).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((entities) => TypeUtils.convert(AdminStatistics, entities)),
			tap((result) => this.logger.debug(`[${this.constructor.name}.${this.getStatistics.name}]`, result))
		);
	}

	getNotAcceptedUsers(query?: FindAllQueryDto<UserInvitation>) {
		return httpService.get<FindAllQueryResponseDto<UserInvitation>>(this.getUrl(), `not-accepted-users`, { params: query }).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((entities) => plainToClassFromExist(new FindAllQueryResponseDto<UserInvitation>(UserInvitation), entities)),
			tap((result) => this.logger.debug(`[${this.constructor.name}.${this.getNotAcceptedUsers.name}]`, result))
		);
	}
}

export const adminService = new AdminService();
